<!-- <div class="route-bar" style="background-color: rgb(0, 74, 173) !important;">
    <div class="route-bar-breadcrumb">
        <i class="fa fa-home" style="color: snow;"></i>
        <span><i class="pi pi-chevron-right" style="color: snow;"></i> </span>
        <ng-template ngFor let-item let-last="last" [ngForOf]="items">
            <a [routerLink]="item.routerLink" *ngIf="item.routerLink" style="color: snow;">{{item.label}}</a>
            <ng-container *ngIf="!item.routerLink" style="color: snow;">{{item.label}}</ng-container>
            <span *ngIf="!last"><i class="pi pi-chevron-right" style="color: snow;"></i></span>
        </ng-template>
    </div>
</div> -->
<div class="route-bar" style="background-color: #0044ad;">
    <div class="route-bar-breadcrumb">
        <i class="fa fa-home" style="color: orange;"  ></i>
        <span><i class="pi pi-chevron-right" style="color: orange;"  ></i> </span>
        <ng-template ngFor let-item let-last="last" [ngForOf]="items">
            <a [routerLink]="item.routerLink" *ngIf="item.routerLink" style="color: orange;" >{{item.label}}</a>
            <ng-container *ngIf="!item.routerLink"><span style="color:white;">{{item.label}}</span></ng-container>
            <span *ngIf="!last"><i class="pi pi-chevron-right" style="color: orange;"  ></i></span>
        </ng-template>
    </div>
</div>
